import categoriesAtom from "../categories";
import { createVisibleCategoriesAtom } from "../create-visible-catalog-atoms";
import categoriesItemOffersAtom from "./categories-item-offers";

/** Categories on the DELIVERY menu right now (inside their window, non-empty). */
const visibleCategoriesAtom = createVisibleCategoriesAtom(categoriesAtom, categoriesItemOffersAtom);

export default visibleCategoriesAtom;
